export function frame(callback)
{
	if(typeof requestAnimationFrame == 'undefined')
	{
		setTimeout(callback, 0)
	}
	else
	{
		requestAnimationFrame(callback)
	}
}



/** WEBPACK FOOTER **
 ** ./source/scripts/utilities.js
 **/